export enum DMN_FUNCIONALIDADE {
  LOGIN = 1,
  BUSCAR_CONTRATOS = 2,
  SELECIONAR_CONTRATO = 3,
  PESQUISAR = 4,
  SELECIONAR_PARTICIPANTE = 5,
  HOME_ATIVOS = 6,
  HOME_ASSISTIDOS = 7,
  ALTERACAO_CADASTRAL = 8,
  EXTRATO_CONTRIBUICAO_PDF = 9,
  COMPROVANTE_RENDIMENTOS_CONSULTA = 10,
  COMPROVANTE_RENDIMENTOS_PDF = 11,
  TROCAR_SENHA = 12,
  FALE_CONOSCO = 13,
  DADOS_PESSOAIS = 14
}